import {NavLink, Outlet, useLocation} from "react-router-dom";
import {buildRoute} from "@router/RouterUtils";
import {AppRoute, RoutePath} from "@router/RoutingModels";
import "./PublicLayout.scss";
import LogoImage from "@/assets/images/logo.png";
import {useAuth} from "@msal/useAuth";
import {useEffect, useState} from "react";
import {LanguagePicker} from "@components/LanguagePicker/LanguagePicker";
import {LogoIcon} from "@components/Icons/LogoIcon";
import {usePublicTranslations} from "@i18n/i18nUtils";
import {UserIcon} from "@components/Icons/UserIcon";
import {publicAssetFullPath} from "@commons/Utils";

export default function PublicLayout() {

    const {loginRedirect} = useAuth();
    const location = useLocation();
    const {t} = usePublicTranslations();
    const [showUserMenu, setShowUserMenu] = useState(false);

    useEffect(() => {

        setShowUserMenu(!([RoutePath.ON_BOARD, RoutePath.OPS].includes(location.pathname)))

    }, [location.pathname]);

    return (
        <div className={`layout`}>

            <header className="layout__header">

                <div className="layout__header__primary">
                    <div className="container full-bleed">
                        <div className="logo">
                            <NavLink to={buildRoute(AppRoute.WELCOME)}>
                                <img src={LogoImage} alt={"logo"}/>
                            </NavLink>
                        </div>
                        {showUserMenu &&
                            <div className="account">
                                <button onClick={() => loginRedirect("SIGNIN")}
                                        className={"cta cta--small cta--secondary cta-account"}>
                                    <span className="icon">
                                        <UserIcon/>
                                    </span>
                                    <span className={"label"}>My Gewiss</span>
                                </button>
                            </div>
                        }
                    </div>
                </div>

            </header>

            <main className="layout__main">
                <Outlet/>
            </main>

            <footer className="layout__footer">
                <div className="container">
                    <div className="layout__footer__top">
                        <div className={"logo"}>
                            <NavLink to={buildRoute(AppRoute.WELCOME)}>
                                <LogoIcon/>
                            </NavLink>
                        </div>
                    </div>
                    <div className="layout__footer__mid">
                        <p className={"tp-2xs color-black"}>
                            {t("public.footer.text")}
                        </p>
                    </div>
                    <div className="layout__footer__bottom">
                        <nav className={"footer-nav"}>
                            <ul>
                                <li>
                                    <NavLink to={publicAssetFullPath(t("public.footer.links.rules.link"))}
                                             target={"_blank"}>{t("public.footer.links.rules.label")}</NavLink>
                                </li>
                                <li>
                                    <NavLink to={t("public.footer.links.privacy.link")}
                                             target={"_blank"}>{t("public.footer.links.privacy.label")}</NavLink>
                                </li>

                                <li>
                                    <NavLink to={buildRoute(AppRoute.COOKIE_POLICY)}>{t("public.footer.links.cookie.label")}</NavLink>
                                </li>
                            </ul>
                        </nav>
                        <LanguagePicker/>
                    </div>
                </div>
            </footer>
        </div>
    );
}
